import React, { Component, Fragment } from "react";
import AUX from "../../../hoc/Aux_";
import AuthService from "../../Auth/AuthService";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import { connect } from "react-redux";
import TextField from "@material-ui/core/TextField";
import paginationFactory from "react-bootstrap-table2-paginator";
import $ from "jquery";
import _ from "lodash";
import notificationService from "../General/NotificationService";
import TableCustomTotal from "../../Shared/TableCustomTotal";
import PermissionFeature from "../../Permissions/PermissionFeature";
import NotificationFunction from "../General/NotificationFunction";
import actions from "../../../store/notificatiommodule/action";

import Columns from "../General/Columns";
import ModuleTable from "./ModuleTable";

class NotificationTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notifications: null,
      table: null,
      filtered: null,
      loading: false,

      expanded: {
        notifications: [],
        triggers: [],
      },
      search: null,
    };
    this.user = AuthService.getProfile().memberData;
    this.getAllModules = this.getAllModules.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }
  componentDidMount() {
    if (AuthService.canView(PermissionFeature.NotificationModule)) {
      this.getAllModules();
    } else {
      this.props.history.push(
        `/dashboard/myProfile/${this.user && this.user.id}`
      );
      return false;
    }
  }
  componentDidUpdate(prevProps) {
    // Simple: Just check if we need to reload
    if (this.props.shouldReload && !prevProps.shouldReload) {
      this.props.fetchNotifications(false);
      this.getAllModules();
    }
  }
  handleNotificationExpand = (row, isExpand) => {
    this.setState((prev) => ({
      expanded: {
        ...prev.expanded,

        notifications: isExpand
          ? [...prev.expanded.notifications, row.id]
          : prev.expanded.notifications.filter((x) => x !== row.id),
      },
    }));
  };
  handleTriggerExpand = (row, isExpand) => {
    this.setState((prev) => ({
      expanded: {
        ...prev.expanded,

        triggers: isExpand
          ? [...prev.expanded.triggers, row.id]
          : prev.expanded.triggers.filter((x) => x !== row.id),
      },
    }));
  };
  getAllModules = async () => {
    //  await this.setState({ loading: true });
    $(".loading").show();
    let data = await notificationService.GetAllNotifications();
    if (data != null) {
      if (!this.state.search) {
        await this.setState({ notifications: data, filteredData: data });
      } else {
        const { filtered, expanded } = NotificationFunction.searchData(
          data,
          this.state.search
        );
        await this.setState({
          notifications: data,
          filteredData: filtered,
          expanded,
        });
      }
    }
    $(".loading").hide();
    //await this.setState({ loading: false });
  };
  handleEdit = (trigger) => {
    console.log("Edit trigger:", trigger);
  };
  handleSearch = (e) => {
    const search = e.target.value;

    const { filtered, expanded } = NotificationFunction.searchData(
      this.state.notifications,
      search
    );

    this.setState({
      search,
      filteredData: filtered,
      expanded,
    });
  };
  render() {
    // New Work
    return (
      <AUX>
        {AuthService.canView(PermissionFeature.NotificationModule) &&
          this.state.notifications != null && (
            <>
              <div className="col-sm-6 app-search">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control rounded border mb-1 w-100"
                    placeholder="Search..."
                    value={this.state.search}
                    onChange={this.handleSearch}
                  />
                </div>
              </div>
              <div className="clearfix"></div>

              <div className="col-12 mt-4">
                {this.state.loading ? (
                  <div
                    class="spinner-border text-center text-primary"
                    role="status"
                  ></div>
                ) : (
                  <ModuleTable
                    data={this.state.filteredData}
                    expanded={this.state.expanded}
                    onNotificationExpand={this.handleNotificationExpand}
                    onTriggerExpand={this.handleTriggerExpand}
                  />
                )}
              </div>
            </>
          )}
      </AUX>
    );
  }
}
const mapStateToProps = (state) => ({
  shouldReload: state.notificationModule.shouldReload, // Direct access since your reducer exports state directly
});

export default connect(mapStateToProps, {
  fetchNotifications: actions.fetchNotifications,
})(NotificationTable);
